// extracted by mini-css-extract-plugin
module.exports = {"icon":"Tooltip_icon__19uij","tooltip":"Tooltip_tooltip__27rxC","tooltiptext":"Tooltip_tooltiptext__13kTA"};